import request from '../../utils/requests'

/**
 * Tag: Student
 */

const baseUrl ="/api/Student";



/**
 * 新增学员
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    Name Desc:学员姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    ImgUrl Desc:头像地址 Required:false
 *    Birthday Desc:学员生日 Required:false
 *    IdCard Desc:学员证件号 Required:false
 *    IdCardType Desc:学员证件类型 Required:false
 *    Guardian Desc:家长姓名 Required:false
 *    Sex Desc:性别 Required:false
 *    StudentTag Desc:标签 Required:false
 *    BranchId Desc:校区ID Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 *    UniqueCode Desc:学员编号 Required:false
 *    WeChat Desc:微信号码 Required:false
 *    QQ Desc:QQ号码 Required:false
 *    ContactPerson Desc:家长电话 Required:false
 *    Address Desc:通信地址 Required:false
 *    Source Desc:学生来源 Required:false
 *    Promoter Desc:推荐人 Required:false
 *    Consultant Desc:学员顾问 Required:false
 *    Remark Desc:备注说明 Required:false
 *    SignDate Desc:报名日期 Required:false
 *    SignNumber Desc:报名编号 Required:false
 *    InsuranceNumber Desc:保险单号 Required:false
 *    InsuranceStartDate Desc:保险投保日期 Required:false
 *    InsuranceEndDate Desc:保险到期日期 Required:false
 *    GroupIdentify Desc:组别 Required:false
 *    School Desc:在读学校 Required:false
 *    ContactPersonIdCard Desc:家长证件号【保险必填】 Required:false
 *    ContactPersonIdCardType Desc:家长证件类型【保险必填】 Required:false
 *    Class Desc:在读班级 Required:false
 *    Speciality Desc:特长 Required:false
 *    IsResidence Desc:是否住校 Required:false
 *    GraduateSchool Desc:毕业学校 Required:false
 *    StudentCode Desc:学籍号 Required:false
 *    StudentNo Desc:学号 Required:false
 * }
 */
async function _add(body) {
  return request(baseUrl+'/add',{
    method: 'POST',
    body: body,
  });

}



/**
 * 批量删除数据（学员课程关系表）
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _delete(body) {
  return request(baseUrl+'/delete',{
    method: 'POST',
    body: body,
  });

}



/**
 * 分页查询（学员课程关系表）
 * @param {*} body
 * {
 *    Name Desc:姓名(精确查询) Required:false
 *    Phone Desc:手机号(精确查询) Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    Sex Desc:性别 Required:false
 *    Birthday Desc:生日开始 Required:false
 *    BirthdayEnd Desc:生日结束 Required:false
 *    BirthdayDate Desc:出生日期开始 Required:false
 *    BirthdayDateEnd Desc:出生日期结束 Required:false
 *    CourseId Desc:课程ID集合 Required:false
 *    ClassId Desc:班级ID集合 Required:false
 *    EffectiveBeginTime Desc:有效期查询开始时间 Required:false
 *    EffectiveEndTime Desc:有效期查询结束时间 Required:false
 *    SignUpBeginTime Desc:报名查询开始时间 Required:false
 *    SignUpEndTime Desc:报名查询结束时间 Required:false
 *    BranchId Desc:校区ID Required:false
 *    IsReading Desc:是否在读（-1：全部，1：在读，0：未在读,2:停课中），默认全部 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging(body) {
  return request(baseUrl+'/paging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取单个学员信息
 * @param {*} param
 * {
 *    StudentId Desc: Required:true
 * }
 */
async function _getModel(param) {
  return request(baseUrl+'/getModel',{
    method: 'POST',
    params: param,
  });

}



/**
 * 更新学员信息
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    Name Desc:学员姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    ImgUrl Desc:头像地址 Required:false
 *    Birthday Desc:学员生日 Required:false
 *    IdCard Desc:学员证件号 Required:false
 *    IdCardType Desc:学员证件类型 Required:false
 *    Guardian Desc:家长姓名 Required:false
 *    Sex Desc:性别 Required:false
 *    StudentTag Desc:标签 Required:false
 *    BranchId Desc:校区ID Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 *    UniqueCode Desc:学员编号 Required:false
 *    WeChat Desc:微信号码 Required:false
 *    QQ Desc:QQ号码 Required:false
 *    ContactPerson Desc:家长电话 Required:false
 *    Address Desc:通信地址 Required:false
 *    Source Desc:学生来源 Required:false
 *    Promoter Desc:推荐人 Required:false
 *    Consultant Desc:学员顾问 Required:false
 *    Remark Desc:备注说明 Required:false
 *    SignDate Desc:报名日期 Required:false
 *    SignNumber Desc:报名编号 Required:false
 *    InsuranceNumber Desc:保险单号 Required:false
 *    InsuranceStartDate Desc:保险投保日期 Required:false
 *    InsuranceEndDate Desc:保险到期日期 Required:false
 *    GroupIdentify Desc:组别 Required:false
 *    School Desc:在读学校 Required:false
 *    ContactPersonIdCard Desc:家长证件号【保险必填】 Required:false
 *    ContactPersonIdCardType Desc:家长证件类型【保险必填】 Required:false
 *    Class Desc:在读班级 Required:false
 *    Speciality Desc:特长 Required:false
 *    IsResidence Desc:是否住校 Required:false
 *    GraduateSchool Desc:毕业学校 Required:false
 *    StudentCode Desc:学籍号 Required:false
 *    StudentNo Desc:学号 Required:false
 * }
 */
async function _update(body) {
  return request(baseUrl+'/update',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取学员数量（总计，在读，停课）
 * @param {*} body
 * {
 *    BranchId Desc:校区id Required:false
 *    CourseId Desc:课程ID Required:false
 *    ClassId Desc:班级ID Required:false
 * }
 */
async function _getStudentCount(body) {
  return request(baseUrl+'/getStudentCount',{
    method: 'POST',
    body: body,
  });

}



/**
 * 导出数据
 * @param {*} body
 * {
 *    Name Desc:姓名(精确查询) Required:false
 *    Phone Desc:手机号(精确查询) Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    Sex Desc:性别 Required:false
 *    Birthday Desc:生日开始 Required:false
 *    BirthdayEnd Desc:生日结束 Required:false
 *    BirthdayDate Desc:出生日期开始 Required:false
 *    BirthdayDateEnd Desc:出生日期结束 Required:false
 *    CourseId Desc:课程ID集合 Required:false
 *    ClassId Desc:班级ID集合 Required:false
 *    EffectiveBeginTime Desc:有效期查询开始时间 Required:false
 *    EffectiveEndTime Desc:有效期查询结束时间 Required:false
 *    SignUpBeginTime Desc:报名查询开始时间 Required:false
 *    SignUpEndTime Desc:报名查询结束时间 Required:false
 *    BranchId Desc:校区ID Required:false
 *    IsReading Desc:是否在读（-1：全部，1：在读，0：未在读,2:停课中），默认全部 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _expExcel(body) {
  return request(baseUrl+'/expExcel',{
    method: 'POST',
    body: body,
  });

}



/**
 * 导入数据
 */
async function _importExcel() {
  return request(baseUrl+'/importExcel',{
    method: 'POST',
  });

}



/**
 * 获取档案信息
 * @param {*} body
 * {
 *    Name Desc:学员姓名 Required:true
 *    Phone Desc:学员手机号 Required:true
 * }
 */
async function _getArchivesInfo(body) {
  return request(baseUrl+'/getArchivesInfo',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取档案排课表
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    StartTime Desc:开始时间 Required:true
 *    EndTime Desc:结束时间 Required:true
 *    BranchId Desc:校区ID Required:false
 * }
 */
async function _getArchivesClassTimeTable(body) {
  return request(baseUrl+'/getArchivesClassTimeTable',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取档案订单详情
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区id Required:false
 *    IsHistory Desc:是否为历史课程(是：历史课程，否：在读课程,null:全部)

后台默认给了false

按照票卡到期时间来判断是否是历史课程 Required:false
 *    CourseId Desc:课程id Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getArchivesOrderDetail(body) {
  return request(baseUrl+'/getArchivesOrderDetail',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取档案课程班级
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区id Required:false
 *    IsHistory Desc:是否为历史课程(是：历史课程，否：在读课程,null:全部)

后台默认给了false

按照票卡到期时间来判断是否是历史课程 Required:false
 *    CourseId Desc:课程id Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getArchivesCourseClass(body) {
  return request(baseUrl+'/getArchivesCourseClass',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取档案上课记录
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    CourseId Desc:课程ID集合 Required:false
 *    CourseClassId Desc:课程班级ID集合 Required:false
 *    ScheduleAttendStatus Desc:课时签到状态 枚举 1：签到 2：请假 3：旷课 4：补课 -1：全部 Required:false
 *    ScheduleAttendType Desc:课时签到方式 枚举 0：手动签到 -1：全部 Required:false
 *    BranchId Desc:校区ID集合 Required:false
 *    StudentType Desc:学员类型，枚举 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getArchivesClassRecord(body) {
  return request(baseUrl+'/getArchivesClassRecord',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取续费预警
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    CourseIdList Desc:课程IDList Required:false
 *    BranchId Desc:校区ID:b Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStudentRenewalWarning(body) {
  return request(baseUrl+'/getStudentRenewalWarning',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取续费预警导出
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    CourseIdList Desc:课程IDList Required:false
 *    BranchId Desc:校区ID:b Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStudentRenewalWarningExp(body) {
  return request(baseUrl+'/getStudentRenewalWarningExp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查询机构相同手机号和姓名的学员
 * @param {*} body
 * {
 *    Name Desc:姓名 Required:false
 *    Phone Desc:手机号 Required:false
 *    OrgId Desc:Orgid过滤 前端无需传入 Required:false
 * }
 */
async function _searchStudent(body) {
  return request(baseUrl+'/searchStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 根据姓名模糊查询学员列表
 * @param {*} param
 * {
 *    name Desc: Required:true
 * }
 */
async function _getStudentListByName(param) {
  return request(baseUrl+'/getStudentListByName',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取学员的校区列表
 * @param {*} param
 * {
 *    studentId Desc: Required:true
 * }
 */
async function _getStudentBranchById(param) {
  return request(baseUrl+'/getStudentBranchById',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取成长记录-学员风采
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID，机构时不传 Required:false
 *    StartDate Desc:开始日期(2019-01-01) Required:true
 *    EndDate Desc:结束日期(2019-01-01) Required:true
 * }
 */
async function _getClassDemeanorForStuResp(body) {
  return request(baseUrl+'/getClassDemeanorForStuResp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取成长记录-课堂风采
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID，机构时不传 Required:false
 *    StartDate Desc:开始日期(2019-01-01) Required:true
 *    EndDate Desc:结束日期(2019-01-01) Required:true
 * }
 */
async function _getClassDemeanorForClassResp(body) {
  return request(baseUrl+'/getClassDemeanorForClassResp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取成长记录-作业展示
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID，机构时不传 Required:false
 *    StartDate Desc:开始日期(2019-01-01) Required:true
 *    EndDate Desc:结束日期(2019-01-01) Required:true
 * }
 */
async function _getHomeworkDisplay(body) {
  return request(baseUrl+'/getHomeworkDisplay',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取成长记录-成长足迹
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID，机构时不传 Required:false
 *    StartDate Desc:开始日期(2019-01-01) Required:true
 *    EndDate Desc:结束日期(2019-01-01) Required:true
 * }
 */
async function _getGrowthFootprint(body) {
  return request(baseUrl+'/getGrowthFootprint',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取成长记录-全部
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区ID，机构时不传 Required:false
 *    StartDate Desc:开始日期(2019-01-01) Required:true
 *    EndDate Desc:结束日期(2019-01-01) Required:true
 * }
 */
async function _getArchivesGrowthRecord(body) {
  return request(baseUrl+'/getArchivesGrowthRecord',{
    method: 'POST',
    body: body,
  });

}



/**
 * 学员档案通过课程结班
 * @param {*} body
 * {
 *    StudentId Desc:学员ID Required:true
 *    BranchId Desc:校区id Required:false
 *    IsHistory Desc:是否为历史课程(是：历史课程，否：在读课程,null:全部)

后台默认给了false

按照票卡到期时间来判断是否是历史课程 Required:false
 *    CourseId Desc:课程id Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getCourseClassForClose(body) {
  return request(baseUrl+'/getCourseClassForClose',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查询学员操作记录
 * @param {*} body
 * {
 *    ClassId Desc:班级id Required:false
 *    StartDate Desc:开始时间 Required:false
 *    EndDate Desc:结束时间 Required:false
 *    OperateUserId Desc:操作人集合 Required:false
 *    OperateType Desc:操作类型 Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    BranchId Desc:校区id Required:false
 *    CourseId Desc:课程id Required:false
 *    ModuleType Desc:操作模块类型 1--添加，移出 ; 2--停复课 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getOperateRecord(body) {
  return request(baseUrl+'/getOperateRecord',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查找学员列表
 * @param {*} param
 * {
 *    studentName Desc:学员名称 Required:true
 *    branchId Desc:校区Id Required:true
 * }
 */
async function _getStudentList(param) {
  return request(baseUrl+'/getStudentList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取未分班学员列表
 * @param {*} body
 * {
 *    BranchId Desc:校区Id Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    CourseId Desc:课程ID Required:false
 *    StartDate Desc:报名时间-开始 Required:false
 *    EndDate Desc:报名时间-结束 Required:false
 *    OrgId Desc:后台使用 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getNoClassStudent(body) {
  return request(baseUrl+'/getNoClassStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 学生保险列表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    StudentIdNo Desc:证件号 Required:false
 * }
 */
async function _getStudentInsuranceOrderList(body) {
  return request(baseUrl+'/getStudentInsuranceOrderList',{
    method: 'POST',
    body: body,
  });

}


/**
 * 获取长期未签到学员列表
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    CourseId Desc:课程ID Required:false
 *    ClassId Desc:报读班级 Required:false
 *    UnmatchDay Desc:未上课天数 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getUnmatchStudent(body) {
  return request(baseUrl+'/getUnmatchStudent',{
    method: 'POST',
    body: body,
  });

}

/**
 * 导出长期未签到学员列表
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    CourseId Desc:课程ID Required:false
 *    ClassId Desc:报读班级 Required:false
 *    UnmatchDay Desc:未上课天数 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
 async function _getUnmatchStudentExp(body) {
  return request(baseUrl+'/getUnmatchStudentExp',{
    method: 'POST',
    body: body,
  });

}



async function _resetPassword(params) {
  return request(baseUrl+'/ResetPassword',{
    method: 'POST',
    body: params,
  });

}




export default{
  _add,
  _delete,
  _paging,
  _getModel,
  _update,
  _getStudentCount,
  _expExcel,
  _importExcel,
  _getArchivesInfo,
  _getArchivesClassTimeTable,
  _getArchivesOrderDetail,
  _getArchivesCourseClass,
  _getArchivesClassRecord,
  _getStudentRenewalWarning,
  _getStudentRenewalWarningExp,
  _searchStudent,
  _getStudentListByName,
  _getStudentBranchById,
  _getClassDemeanorForStuResp,
  _getClassDemeanorForClassResp,
  _getHomeworkDisplay,
  _getGrowthFootprint,
  _getArchivesGrowthRecord,
  _getCourseClassForClose,
  _getOperateRecord,
  _getStudentList,
  _getNoClassStudent,
  _getStudentInsuranceOrderList,
  _getUnmatchStudent,
  _getUnmatchStudentExp,
  _resetPassword

}




// WEBPACK FOOTER //
// ./src/services/student.js